/*! @pentacode/ui v0.1.0 */
import { fieldOf as e } from "./table.util.js";
//#region src/elements/table/table-autosize.ts
var t = {
	position: "absolute",
	visibility: "hidden",
	whiteSpace: "nowrap",
	display: "inline-block",
	padding: "var(--ptc-ui-table-cell-padding, 0.5rem)",
	boxSizing: "border-box",
	font: "inherit"
};
function n() {
	let e = document.createElement("div");
	return Object.assign(e.style, t), e;
}
function r(e, t, n, r) {
	let i = CSS.escape(t), a = e.querySelectorAll(`td[data-field="${i}"]`), o = e.querySelector(`th[data-field="${i}"]`);
	if (a.length === 0 && !o) return 0;
	let s = 0, c = o ? {
		position: o.style.position,
		width: o.style.width,
		gridColumn: o.style.gridColumn
	} : null;
	try {
		r && o && (o.style.position = "absolute", o.style.width = "max-content", o.style.gridColumn = "auto", s = Math.max(s, o.offsetWidth));
		for (let e of a) n.replaceChildren(...Array.from(e.childNodes, (e) => e.cloneNode(!0))), s = Math.max(s, n.offsetWidth);
	} finally {
		o && c && Object.assign(o.style, c);
	}
	return s;
}
function i(e, t, i = {}) {
	let { includeHeader: a = !0 } = i, o = n();
	e.appendChild(o);
	try {
		return r(e, t, o, a);
	} finally {
		o.remove();
	}
}
function a(t, i, a = {}) {
	let { includeHeader: o = !0 } = a, s = /* @__PURE__ */ new Map(), c = n();
	t.appendChild(c);
	try {
		for (let n of i) {
			if (n.hide) continue;
			let i = r(t, e(n), c, o);
			if (i > 0) {
				let t = n.minWidth ?? 40, r = n.maxWidth ?? Infinity;
				s.set(e(n), Math.round(Math.min(r, Math.max(t, i + 2))));
			}
		}
	} finally {
		c.remove();
	}
	return s;
}
//#endregion
export { a as measureAllColumns, i as measureColumn };

//# sourceMappingURL=table-autosize.js.map